import { useState } from "react";
import { Link } from "react-router-dom";
import { api, track } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      track("forgot_password_requested");
      setSent(true);
    } catch {
      setSent(true); // never reveal whether the email exists
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FCFAF6] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2.5">
          <span className="w-10 h-10 rounded-2xl bg-[#291B2D] text-white flex items-center justify-center font-heading text-lg">S<span className="text-[#C89B55]">+</span></span>
          <span className="font-heading text-2xl">Sisterhood<span className="text-[#C89B55]">+</span></span>
        </Link>
        {sent ? (
          <div data-testid="forgot-sent" className="mt-8">
            <h1 className="font-display text-3xl font-semibold">Check your inbox</h1>
            <p className="text-[#59535B] mt-3 leading-relaxed">
              If an account exists for <strong>{email}</strong>, we've sent a link to reset your password.
              It expires in 1 hour. Be sure to check your spam folder too.
            </p>
            <Link to="/login" className="mt-8 inline-block rounded-full bg-[#291B2D] text-[#FCFAF6] px-7 py-3.5 font-medium hover:bg-[#352238] transition-all">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl lg:text-4xl font-semibold mt-8">Reset your password</h1>
            <p className="text-[#59535B] mt-2">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <input data-testid="forgot-email-input" type="email" required value={email} placeholder="you@example.com"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#FCFAF6] border border-[#E5DED4] rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C89B55]" />
              <button data-testid="forgot-submit" type="submit" disabled={loading}
                className="w-full rounded-full bg-[#291B2D] text-[#FCFAF6] hover:bg-[#352238] transition-all px-7 py-3.5 font-medium disabled:opacity-60">
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <Link to="/login" className="mt-6 inline-block text-sm text-[#8A838E] hover:text-[#291B2D] underline underline-offset-4">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
